import { matrixOtherValidator, reduceValidationResults } from '../validators';
import { t } from '../../../utils/translate';

export const compareCurrentSum = state => {
  const sumMatches = state.currentSum === state.sum;
  const isUntouched = state.rows.some(row => !row.isTouched);
  const isAllBlank = state.rows.every(row => row.value === '');
  const isNoneSelected = state.none;
  const isForgiven = isUntouched || isAllBlank || isNoneSelected;
  const isValid = sumMatches || isForgiven;
  const errorMessages = isValid
    ? null
    : state.errorMessages.concat([t('constant_sum_no_match')]);
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const required = state => {
  const fieldValids = state.rows.map(row => !!row.value.length || row.other);
  const isForgiven = state.rows.some(row => !row.isTouched);
  const allFieldsValid = fieldValids.every(v => v === true);
  const isNoneSelected = state.none;
  const isValid = allFieldsValid || isNoneSelected || isForgiven;
  const errorMessages = isValid
    ? null
    : state.errorMessages.concat([t('must_make_one_entry_per_row')]);
  return reduceValidationResults(state, {
    errorMessages,
    fieldValids,
    isValid,
  });
};

export const addOther = matrixOtherValidator;
